import {Component,Input, OnInit, ViewChild} from '@angular/core';
import {ReportItem} from "../report-item";
import {Items} from "../../../@models/pdf-report/items";

@Component({
	selector: 'app-pdf-view-blocks-other',
	templateUrl: './pdf-view-blocks-other.component.html',
	styleUrls: ['./pdf-view-blocks-other.component.scss']
})
export class PdfViewBlocksOtherComponent implements OnInit, ReportItem {

	@Input()
	tableData: Items;

	constructor() {
	}
	@ViewChild('element', { static: true })
	public element;

	ngOnInit() {
		console.log(this.tableData);
	}
}
